import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';


function RadioButtonList(props) {
  function isChecked(value, parentState) {
    return value === parentState;
  }

  const radioButtons = props.options.map((option) => (
    <FormGroup check inline>
      <Label className="sm-text" check key={option.en}>
        <Input
          type="checkbox"
          checked={isChecked(option.en, props.value)}
          onChange={() => props.handleChange(option.en, props.id)}
        />
        {' '}
        {props.activeLanguage.code === 'gb' ? option.en : option.fr}
      </Label>
    </FormGroup>
  ));

  return (
    <div className="text-left" style={{ marginBottom: '15px' }}>
      {radioButtons}
    </div>
  );
}


RadioButtonList.propTypes = {
  handleChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  value: PropTypes.string.isRequired,
};

export default withLocalize(RadioButtonList);
